<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="HquienesSomos">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>QUIÉNES SOMOS</h1>
                    <p><strong>Fundación Best A.C.</strong> (Asociación Civil), institución médica privada orgullosamente mexicana y sin fines de lucro, inicia sus actividades el 19 de octubre de 1994, con la única misión de ayudar a los que menos tienen, mediante el establecimiento de consultorios médicos y su División Asistencial, área que con el tiempo se constituiría de manera independiente y adquiriría su actual nombre de: Fundacion del Dr Simi. Posteriormente en 1996 en la Ciudad de Cuernavaca, se crea el modelo <span class="txtBold">"Unidos para Ayudar"</span> con el que fomenta el apoyo mutuo y el intercambio de experiencias entre las Instituciones que se apoyan.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
<div class="contenedorIntSub">
    <div class="FcfrCst">
        <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
            <div class="dCuatro FcfrBllt" *ngFor="let cifra of cifras">
                <img src="{{cifra.urlImagen}}" alt="{{cifra.concepto}}" />
                <p class="FcifrasDatos">+ {{cifra.cantidad | number}}</p>
                <p [innerHTML]="cifra.concepto"></p>
            </div>
        </div>
    </div>

    <div class="espacioDefault"></div>

    <div class="dNueve dtDiez dmOnce FQuienesSomos">
        <p>
            A través del tiempo, la institución ha crecido en número de médicos comodatarios, consultorios, servicios, supervisores y áreas administrativas, que en conjunto han formado un solo equipo, pilar central de la Vicepresidencia de Salud del <strong>Grupo Por Un País Mejor</strong>, cuya meta es atender a la población, sin importar condición social, económica y cultural, buscando siempre otorgar servicios médicos de calidad y calidez a un costo accesible, en amplios horarios de atención los 365 días del año, con más de <span style="font-weight: 700;">{{medicosT | number}}</span> médicos egresados de las mejores universidades del país, los cuales cuentan con título, cédula  profesional, y certificación, contando siempre con instalaciones y equipo de primer nivel, de ahí los resultados, pues se están otorgando <span style="font-weight: 700;">{{consultas | number}}</span> consultas al mes, en los <span style="font-weight: 700;">{{Consultorios | number}}</span> consultorios que tenemos en todo el país, con lealtad a nuestro lema  <strong>“Unidos Para Ayudar”</strong>.
        </p>
    </div>

    <div class="FcntHf flx">
        <div id="FimgCntHf" class="FcntHimg dDoce text-center">
            <img src="./assets/images/quienes-estetoscopio.jpg" width="100%" alt="Consulta médica" />
        </div>
        <div class="FcntHtexto">
            <h2>HISTORIA</h2>
            <p>
                <strong>La Fundación Best A.C.</strong>, cuyo lema es <span class="txtBold">“para ayudar a los que menos tienen”</span>, nace con objetivos como dar atención a personas que por sus carencias socioeconómicas o de discapacidad están impedidas para satisfacer sus requerimientos básicos de subsistencia y desarrollo.<br/><br/>
                Inicia sus actividades el 19 de octubre de 1994, con la única misión de ayudar a los que menos tienen, mediante el establecimiento de consultorios médicos y su división asistencial.<br/><br/>
                En 1996 en la ciudad de Cuernavaca se crea el modelo "Unidos para Ayudar" con el que fomenta el apoyo mutuo y el intercambio de experiencias entre las instituciones que se apoyan.<br/><br/>
                En octubre de 1997 nace el Servicio Médico de Fundación Best, A. C., contando con dos elementos médicos, prestando atención médica gratuita en apoyo a la labor social de Farmacias Similares, en Antillas No. 318-A Col. Portales, México, D. F., con la finalidad de prestar atención médica de excelente calidad humana y profesional a la población de escasos recursos que por sus condiciones socioeconómicas no pueden acceder a servicios médicos.<br/><br/>
                Actualmente a través de un contrato de comodato se brinda consulta en <span style="font-weight: 700;">{{Consultorios|number}}</span> consultorios médicos instalados con un grupo de <span style="font-weight: 700;">{{medicosT|number}}</span> médicos.
            </p>
        </div>
    </div>
</div>

    <div class="Fetica">
        <div class="FetiInt flx maxCnt">
            <div class="dCuatro dtDoce dmDoce">
                <div id="Fmision">
                    <h2>MISIÓN</h2>
                    <p>Ayudar a los que menos tienen, a través de servicios médicos y de asistencia, elevando con ello sus condiciones de salud y de vida.</p>
                </div>
                <div id="Fvision">
                    <h2>VISIÓN</h2>
                    <p>Brindar ayuda asistencial y acercar servicios de salud a todos los mexicanos, impedidos a satisfacer sus requerimientos básicos de subsistencia.</p>
                </div>
            </div>
            <div class="dCuatro dtDoce dmDoce">
                <div class="dDoce" id="Fvalores">
                    <img src="./assets/images/icon-valores.png" alt="Valores" />
                    <h2>VALORES</h2>
                    <br/>
                    <ul>
                        <li>GENEROSIDAD</li>
                        <li>COMPROMISO</li>
                        <li>SERVICIO</li>
                        <li>CALIDAD</li>
                        <li>CALIDEZ</li>
                    </ul>
                </div>
            </div>
            <div class="dCuatro dtDoce dmDoce">
                <div class="dDoce" id="Fprincipios">
                    <img src="./assets/images/icon-principios.png" alt="Principios" />
                    <h2>PRINCIPIOS</h2>
                    <br/>
                    <ul>
                        <li>ÉTICA</li>
                        <li>RESPETO</li>
                        <li>LEALTAD</li>
                        <li>HONESTIDAD</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</div>